import styled from 'styled-components'
import { t } from 'i18next'
import { usePopup } from '@/core/context/useWindow'

/**
 * 「最新ニュース」 창 — 공지 띠(GoldNews)를 누르면 뜬다. 띠에 흐르는 줄을 목록으로 보여준다.
 *   gold8.bet PC(.marqueeDialog): 폭 600, 회색 머리 + 파란 제목, 점선으로 나눈 목록(안에서 스크롤), 회색 「閉鎖」 버튼.
 *   gold8.bet 모바일: 흰 창, 왼쪽 정렬 검은 큰 제목 + 오른쪽 위 x, 오른쪽 아래 「閉じる」 버튼.
 */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.6);
`

const Box = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${({ $mobile }) => ($mobile
    ? `top: 110px; width: calc(100% - 24px); max-height: calc(100% - 160px);
       border-radius: 8px; background: #fff;`
    : `top: 140px; width: 600px; max-width: calc(100% - 40px);
       border-radius: 4px; background: #ececec;`)}
`

const Head = styled.div`
  position: relative;
  flex: 0 0 auto;
  ${({ $mobile }) => ($mobile
    ? `padding: 26px 24px 20px; border-bottom: 1px solid #e3e3e3;
       font-size: 28px; font-weight: 500; color: #222; text-align: left;`
    : `padding: 16px 0; border-bottom: 1px solid #d0d0d0; background: #e9e9e9;
       font-size: 22px; font-weight: 700; color: #2a7de1; text-align: center;`)}
`

const X = styled.button`
  position: absolute;
  top: 18px;
  right: 20px;
  padding: 0;
  border: 0;
  background: none;
  font-size: 22px;
  color: #c4c4c4;
  cursor: pointer;
`

const Body = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  ${({ $mobile }) => ($mobile
    ? 'max-height: 520px; padding: 10px 24px 10px 30px;'
    : 'max-height: 380px; padding: 6px 50px 6px 50px; background: #ececec;')}
`

const List = styled.ul`
  margin: 0;
  padding: 0 0 0 18px;
  list-style: disc;
`

const Item = styled.li`
  padding: ${({ $mobile }) => ($mobile ? '14px 0' : '4px 0')};
  border-bottom: 1px dashed ${({ $mobile }) => ($mobile ? '#c8c8c8' : '#9a9a9a')};
  font-size: ${({ $mobile }) => ($mobile ? '17px' : '13px')};
  line-height: ${({ $mobile }) => ($mobile ? 1.6 : 2)};
  color: #222;
  white-space: pre-wrap;
  word-break: break-all;
  &:last-child { border-bottom: 0; }
`

const Foot = styled.div`
  flex: 0 0 auto;
  display: flex;
  ${({ $mobile }) => ($mobile
    ? 'justify-content: flex-end; padding: 16px 20px; border-top: 1px solid #e3e3e3;'
    : 'justify-content: center; padding: 18px 0; border-top: 1px solid #d0d0d0; background: #e4e4e4;')}
`

const CloseBtn = styled.button`
  cursor: pointer;
  ${({ $mobile }) => ($mobile
    ? `height: 44px; padding: 0 22px; border: 1px solid #c8c8c8; border-radius: 6px;
       background: #fff; font-size: 17px; color: #333;`
    : `width: 115px; height: 40px; border: 1px solid #aaa; border-radius: 4px;
       background: linear-gradient(#fafafa, #d6d6d6); font-size: 14px; font-weight: 700; color: #222;`)}
`

export default function GoldNewsModal({ lines = [], mobile = false }) {
  const { closePopup } = usePopup()
  return (
    <Overlay onClick={(e) => { if (e.target === e.currentTarget) closePopup() }}>
      <Box $mobile={mobile} role="dialog" aria-modal="true">
        <Head $mobile={mobile}>
          {t('grandMain.news_title')}
          {mobile && <X type="button" aria-label="close" onClick={closePopup}>x</X>}
        </Head>
        <Body $mobile={mobile}>
          <List>
            {lines.map((l, i) => <Item key={i} $mobile={mobile}>{l}</Item>)}
          </List>
        </Body>
        <Foot $mobile={mobile}>
          <CloseBtn type="button" $mobile={mobile} onClick={closePopup}>
            {mobile ? t('gold.close') : t('winNotice.close')}
          </CloseBtn>
        </Foot>
      </Box>
    </Overlay>
  )
}
